import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { MainTransitionEvents } from "../../view/abstract/display/GameMainTransition";
import { GameTailTotesSoundEvents } from "../event/GameSountEvent";
import { FeatureFishFoodEvents } from "../../view/abstract/display/features/fishfood/FeatureFishFood";
export class GameSoundTailTotesController extends SoundController {
    addEventListeners() {
        super.removeEventListeners();
        this.registerGame(FeatureFishFoodEvents.SHOW, this.playMusic);
        this.registerGame(GameTailTotesSoundEvents.PICK, this.handlePick);
        this.registerGame(GameTailTotesSoundEvents.TRAIL_WOOSH, this.handleTrailWoosh);
        this.registerGame(GameTailTotesSoundEvents.BAG_REVEAL_MISS, this.handleBagRevealMiss);
        this.registerGame(GameTailTotesSoundEvents.SYMBOLS_FADE, this.handleSymbolsFade);
        this.registerGame(GameTailTotesSoundEvents.PRIZE_LEVEL_1, this.handlePrizeLevel1);
        this.registerGame(GameTailTotesSoundEvents.PRIZE_LEVEL_2, this.handlePrizeLevel2);
        this.registerGame(GameTailTotesSoundEvents.PRIZE_LEVEL_3, this.handlePrizeLevel3);
        this.registerGame(GameTailTotesSoundEvents.PRIZE_LEVEL_4, this.handlePrizeLevel4);
        this.registerGame(GameTailTotesSoundEvents.MOUSE_REVEAL, this.handleMouseReveal);
        this.registerGame(GameTailTotesSoundEvents.MOUSE_PICK, this.handleMousePick);
        this.registerGame(GameTailTotesSoundEvents.PRIZE_MONEY_COLLECT, this.handlePrizeMoneyCollect);
        this.registerGame(MainTransitionEvents.BLACKOUT_MID_POINT, this.stopMusic);
    }
    playMusic() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_MUSIC"));
    }
    stopMusic() {
        this.stopSound(this.getSoundPropertiesFromId("TOTES_MUSIC"));
    }
    handlePick() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_PICK"));
    }
    handleTrailWoosh() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_TRAIL_WOOSH"));
    }
    handleMouseReveal() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_MOUSE_REVEAL"));
    }
    handleMousePick() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_MOUSE_PICK"));
    }
    handleBagRevealMiss() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_BAG_REVEAL_MISS"));
    }
    handleSymbolsFade() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_SYMBOLS_FADE"));
    }
    handlePrizeLevel1() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_PRIZE_LEVEL_1"));
    }
    handlePrizeLevel2() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_PRIZE_LEVEL_2"));
    }
    handlePrizeLevel3() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_PRIZE_LEVEL_3"));
    }
    handlePrizeLevel4() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_PRIZE_LEVEL_4"));
    }
    handlePrizeMoneyCollect() {
        this.playSound(this.getSoundPropertiesFromId("TOTES_MONEY_COLLECT"));
    }
}
//# sourceMappingURL=GameSoundTailTotesController.js.map